import { render, staticRenderFns } from "./AdminWorkFlowHistoryActivityDetail.vue?vue&type=template&id=5b9e97e8&scoped=true"
import script from "./AdminWorkFlowHistoryActivityDetail.vue?vue&type=script&lang=js"
export * from "./AdminWorkFlowHistoryActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminWorkFlowHistoryActivityDetail.vue?vue&type=style&index=0&id=5b9e97e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e97e8",
  null
  
)

export default component.exports